













import Vue from 'vue'

export default Vue.extend({
  props: {
    value: {
      type: String as () => string,
      default: '',
    },
    placeholder: {
      type: String as () => string,
      default: '',
    },
    hideClear: {
      type: Boolean as () => boolean,
      default: false,
    },
  },
  computed: {
    hasValue(): boolean {
      return this.value !== ''
    },
    text(): string {
      return this.hasValue ? this.value : this.placeholder
    },
  },
})
